export var FileUploadStatus;
(function (FileUploadStatus) {
    FileUploadStatus["Available"] = "AVAILABLE";
    FileUploadStatus["Pending"] = "PENDING";
    FileUploadStatus["Deleted"] = "DELETED";
})(FileUploadStatus || (FileUploadStatus = {}));
